import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

class FormInvalidError extends React.Component {
    render() {
        return (
            <FormattedMessage id={this.props.field_name}>
                {
                    (field) =>
                        <FormattedMessage id={"CMS.Form.field.invalid"}
                            values={{ field: field }}>
                            {
                                (message) => <p>{message}</p>
                            }
                        </FormattedMessage>
                }
            </FormattedMessage>
        );
    }
}

FormInvalidError.propTypes = {
    field_name: PropTypes.string.isRequired,
};
export default FormInvalidError